var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTools = function SvgTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m1.414 9.514 3.888-7A1 1 0 0 1 6.177 2h7.646a1 1 0 0 1 .874.514l3.89 7a1 1 0 0 1 0 .972l-3.89 7a1 1 0 0 1-.874.514H6.177a1 1 0 0 1-.875-.514l-3.888-7a1 1 0 0 1 0-.972ZM4.428 2.03l-3.888 7a2 2 0 0 0 0 1.942l3.888 7A2 2 0 0 0 6.177 19h7.646a2 2 0 0 0 1.748-1.029l3.89-7a2 2 0 0 0 0-1.942l-3.89-7A2 2 0 0 0 13.823 1H6.177a2 2 0 0 0-1.749 1.029ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm1 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgTools;